import React from "react";

const KeyFocus = ({ areas }) => {
  return (
    <div className="bg-[#4A627C]">
      <div className="max-w-6xl mx-auto md:p-10 p-3 space-y-5">
        <div>
          <p className="text-white font-bold  text-lg md:text-xl ">
            Key Focus Area
          </p>
        </div>
        <div className="bg-sdbodywhite h-0.5 w-10 my-2"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {areas &&
            areas.map((area, index) => (
              <div key={index} className="p-4 rounded-lg bg-[#FFC8A0]">
                <div className="mb-2 bg-[#634902]">
                  <p className=" text-sm md:text-base text-white p-3 text-center">
                    {area.title}
                  </p>
                </div>
                <div>
                  <p className="text-sm md:text-base">{area.description}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFocus;
